var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackgroundStrokeIcon = function SvgBackgroundStrokeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    preserveAspectRatio: "none",
    viewBox: "0 0 499 252.5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f7b225",
    d: "M499 0S337.7 325.9 0 237.2V65.6c23.2 18.9 79.3 52.7 166.9 32.1C223.6 84.3 267.3 41.2 297.5 0z"
  })));
};
export default SvgBackgroundStrokeIcon;